module.exports = __webpack_public_path__ + "img/bg_login_01.795f33bc.jpg";